import { createSlice } from '@reduxjs/toolkit';

import { CalculatedDelivery, FlightStatus } from 'models/shipments';

export interface DeliveryEstimateState {
  calculatedEdd: CalculatedDelivery | null;
  eddText: string | null;
  timeWindowText: string | null;
  latestEdd: string | null;
  flightStatus: FlightStatus | null;
  analytics: string;
}

export const initialState: DeliveryEstimateState = {
  calculatedEdd: null,
  eddText: null,
  timeWindowText: null,
  latestEdd: null,
  flightStatus: null,
  analytics: 'not shown',
};

export const deliveryEstimateSlice = createSlice({
  name: 'inlineEdd',
  initialState,
  reducers: {
    setInlineEdd: (state, action) => {
      state.calculatedEdd = action.payload;
    },
    setDeliveryEstimateInfo: (state, action) => {
      if (action.payload) {
        state.calculatedEdd = action.payload.calculatedEdd;
        state.eddText = action.payload.eddText;
        state.timeWindowText = action.payload.timeWindowText;
        state.latestEdd = action.payload.latestEdd;
        state.flightStatus = action.payload.flightStatus;
        state.analytics = action.payload.analytics;
        return;
      }
      state.eddText = null;
      state.timeWindowText = null;
      state.latestEdd = null;
      state.flightStatus = null;
    },
  },
});

export const { setInlineEdd, setDeliveryEstimateInfo } = deliveryEstimateSlice.actions;
